import React, { useMemo } from "react";
import { IntlProvider as ReactIntlProvider } from "react-intl";
import { db } from "../db/state";
import { useValue } from "../lib/db/react";
import { messages } from "./locales";

const getLocaleOverride = (): string | null => {
  try {
    return new URLSearchParams(window.location.search).get("locale");
  } catch {
    return null;
  }
};

const resolveMessages = (locale: string): Record<string, string> | undefined => {
  // Exact match
  if (messages[locale]) return messages[locale];
  // Try base language (e.g. "en" from "en-US")
  const base = locale.split("-")[0];
  if (base !== locale && messages[base]) return messages[base];
  // Fallback to English
  return messages["en"];
};

const IntlProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const dbLocale = useValue(db, "locale");
  const override = useMemo(() => getLocaleOverride(), []);
  const locale = override || dbLocale;
  const msgs = resolveMessages(locale);

  return (
    <ReactIntlProvider locale={locale} messages={msgs || {}}>
      {children}
    </ReactIntlProvider>
  );
};

export default IntlProvider;
